import Icon from '@/components/ui/AppIcon';

interface Feature {
  icon: string;
  title: string;
  description: string;
  color: string;
}

const features: Feature[] = [
  {
    icon: 'CloudArrowDownIcon',
    title: 'Offline Listening',
    description: 'Download your favorite stories and listen anytime, anywhere without internet connection.',
    color: 'bg-primary/10 text-primary'
  },
  {
    icon: 'BoltIcon',
    title: 'Smart Recommendations',
    description: 'AI-powered suggestions based on your listening history and preferences.',
    color: 'bg-secondary/10 text-secondary'
  },
  {
    icon: 'AdjustmentsHorizontalIcon',
    title: 'Playback Controls',
    description: 'Variable speed, sleep timer, bookmarks, and seamless cross-device sync.',
    color: 'bg-accent/10 text-accent'
  },
  {
    icon: 'GlobeAltIcon',
    title: 'Multi-Language Support',
    description: 'Stories in 15+ Indian languages including Hindi, Tamil, Telugu, Bengali, and more.',
    color: 'bg-success/10 text-success'
  },
  {
    icon: 'UserGroupIcon',
    title: 'Community Features',
    description: 'Share reviews, create playlists, and connect with fellow story enthusiasts.',
    color: 'bg-warning/10 text-warning'
  },
  {
    icon: 'ShieldCheckIcon',
    title: 'Ad-Free Experience',
    description: 'Premium members enjoy uninterrupted storytelling with zero advertisements.',
    color: 'bg-primary-dark/10 text-primary-dark'
  }
];

export default function FeaturesShowcase() {
  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-text-primary mb-4">
            Powerful Features for<br />
            <span className="text-primary">Immersive Storytelling</span>
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Experience audio stories like never before with features designed for the modern listener
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-card p-8 rounded-2xl border border-border hover:border-primary transition-all duration-300 hover:shadow-warm-lg hover:-translate-y-1"
            >
              <div className={`w-16 h-16 ${feature.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <Icon name={feature.icon as any} size={32} />
              </div>
              <h3 className="text-xl font-heading font-bold text-text-primary mb-3">
                {feature.title}
              </h3>
              <p className="text-text-secondary leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}